module.exports = __webpack_public_path__ + "static/media/YM80_3.4359a04c.jpg";